import { render, staticRenderFns } from "./RoiFormDialog.vue?vue&type=template&id=7198af52"
import script from "./RoiFormDialog.vue?vue&type=script&lang=js"
export * from "./RoiFormDialog.vue?vue&type=script&lang=js"
import style0 from "./RoiFormDialog.vue?vue&type=style&index=0&id=7198af52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports